import { Sequence, SequenceItem } from "../audio/Sequence.js";

export interface SeekOptions {
    container: HTMLElement;
    sequence: Sequence;
}

export class Seek {
    private _element: HTMLElement;
    private _duration: number = 0;
    private _handle: HTMLElement;
    private _trackHandle: HTMLElement;
    private _actor: e5.Click;
    private _sequence: Sequence;

    constructor(options: SeekOptions) {
        options = e5.object.merge({

        }, options);

        this._element = document.createElement("div");
        this._element.className = "seek";
        this._element.innerHTML = `
        <div class="seek__content">
            <div class="seek__track seek__track--background"></div>
            <div class="seek__track seek__track--bars"></div>
            <div class="seek__track seek__track--progress"></div>
            <div class="seek__track seek__track--handle">
                <div class="seek__handle e5-hidden"></div>
            </div>
        </div>
        `;

        this._handle = this._element.querySelector(".seek__handle");
        this._trackHandle = this._element.querySelector(".seek__track--handle");

        this._sequence = options.sequence;

        this._actor = new e5.Click(
            this._trackHandle,
            {
                preventDefault: true
            }
        );

        let up = () => {
            const local = e5.Transform.toLocal(this._trackHandle, this._actor.pointer.x, this._actor.pointer.y);
            const ratio = e5.Calc.clamp(local.x / this._trackHandle.offsetWidth, 0, 1);
            const time = ratio * this._duration;
            this.updateProgress(time);
            return time;
        };

        this._actor.onStart.add(() => {
            up();
        });

        this._actor.onMove.add(() => {
            up();
        });

        this._actor.onClear.add(() => {
            const time = up();
            this._sequence.time = time;
            // this._sequence.play();
        });

        options.container.appendChild(this._element);

        // const t = this._sequence.onChangeItems.throttle((s) => {
        //     this.updateItems(s.items, s.time);
        // }, 200);
        // this._sequence.onTime.add((s) => {
        //     if(t.isThrottling){
        //         return;
        //     }
        //     this.updateTime(s.time);
        // });

        this._sequence.onChangeItems.add((s) => {
            this.updateItems(s.items, s.time);
        }, 200);
        this._sequence.onTime.add((s) => {
            this.updateTime(s.time);
        });
    }

    private updateItems(items: SequenceItem[], time: number): void {
        this._duration = 0;
        for (let item of items) {
            this._duration += item.melody.duration / item.speed;
        }

        let html = ``;
        for (let item of items) {
            let w = ((item.melody.duration / item.speed) / this._duration) * 100;
            html += `<div class="seek__track-item" style="width: ${w.toFixed(8)}%;">
                <div class="seek__track-item-fill"></div>
            </div>`;
        }
        this._element.querySelector(".seek__track--bars").innerHTML = html;
        this._element.querySelector(".seek__track--progress").innerHTML = html;

        this._handle.classList.toggle("e5-hidden", !this._duration);

        this.updateTime(time);
    }

    private updateTime(time: number): void {
        if (this._actor.count > 0) {
            return;
        }
        this.updateProgress(time);
    }

    private updateProgress(time: number): void {
        this._handle.classList.toggle("e5-hidden", !this._duration);
        if (!this._duration) {
            return;
        }

        let ratio = e5.Calc.clamp((time / this._duration) * 100, 0, 100);
        if (ratio > 99.9) {
            ratio = 100;
        }

        this._handle.style.left = ratio.toFixed(8) + "%";

        let progress: HTMLElement = this._element.querySelector(".seek__track--progress");
        progress.style.clipPath = `inset(0 ${(100 - ratio).toFixed(8) + "%"} 0 1px)`;
    }
}